/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Archon_Import_ErrorInputs */



/**
* | output |
* | --- |
* | "Import failed" |
*
* @param {Archon_Import_ErrorInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const archon_import_error = /** @type {((inputs?: Archon_Import_ErrorInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Archon_Import_ErrorInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Échec de l'importation")
	if (locale === "es") return /** @type {LocalizedString} */ ("Error en la importación")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Falha na importação")
	if (locale === "it") return /** @type {LocalizedString} */ ("Importazione non riuscita")
	return /** @type {LocalizedString} */ ("Import failed")
});